import { render, staticRenderFns } from "./ScanforAcceptPacketShape2.vue?vue&type=template&id=06e85754"
import script from "./ScanforAcceptPacketShape2.vue?vue&type=script&lang=ts"
export * from "./ScanforAcceptPacketShape2.vue?vue&type=script&lang=ts"
import style0 from "./ScanforAcceptPacketShape2.vue?vue&type=style&index=0&id=06e85754&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports